import { z } from 'zod'
import { QuizType } from '@/core/domain/resources/enums/QuizType.ts'

export const DashboardClassroomDiagnosticTriggerSchema = z.object({
  id: z.number(),
  schoolClassroomId: z.number(),
  quizId: z.number(),
  quizType: z.nativeEnum(QuizType.Values),
  triggerTime: z.string().datetime(),
  createdByUser: z.string()
})

export const DashboardClassroomDiagnosticTriggerListSchema = z.array(
  DashboardClassroomDiagnosticTriggerSchema
)

export const DashboardClassroomDiagnosticTriggerInputSchema = z.object({
  id: z.number(),
  schoolClassroomId: z.number(),
  learningCourseName: z.string(),
  quizType: z.nativeEnum(QuizType.Values),
  triggerTime: z.string().datetime()
})

// Types dérivés des schemas
export type DashboardClassroomDiagnosticTriggerEntity = z.infer<
  typeof DashboardClassroomDiagnosticTriggerSchema
>
export type DashboardClassroomDiagnosticTriggerInputEntity = z.infer<
  typeof DashboardClassroomDiagnosticTriggerInputSchema
>
